import React, { useEffect } from 'react';
import {
  ensureRecaptchaLoaded,
} from './recaptchaIntegration';
import { getTextStyles } from 'app/components/presentation/text/styles';
import { GREY_S } from 'app/constants/Colors';
import Link from 'app/components/presentation/link/Link';
import { useCss } from 'app/utils/css';
import { useI18n } from 'app/components/localization';

/**
 * Renders a "this site uses reCAPTCHA" legal message. We must manually render
 * our own legal message, because we hide the built in reCAPTCHA UI, which
 * sometimes causes issues with our UI (e.g. the positioning or z-index is
 * sometimes wrong).
 *
 * This also pre-loads the recaptcha code on mount as an optimization.
 */
export function RecaptchaMessage() {
  usePreloadRecaptcha();

  const { t, locale } = useI18n();
  const css = useCss();

  // Text and layout based on reCAPTCHA's sticky badge UI
  return (
    <div
      className={css('recaptchaMessage', {
        ...getTextStyles({ color: GREY_S, fontSize: '12px', letterSpacing: '0.8px' }),
        textAlign: 'center',
        margin: '1em',
      })}
    >
      {t('auth.recaptcha.message')}

      <br />

      <Link to={`https://policies.google.com/privacy?hl=${locale}`} target="_blank">
        {t('auth.recaptcha.policy-link')}
      </Link>

      {' - '}

      <Link to={`https://policies.google.com/terms?hl=${locale}`} target="_blank">
        {t('auth.recaptcha.terms-link')}
      </Link>
    </div>
  );
}

export function usePreloadRecaptcha() {
  useEffect(() => {
    // This is just an optimization: start loading the scripts necessary for
    // recaptcha as soon as this element is rendered, instead of waiting until
    // getRecaptchaToken() is called to load them.
    ensureRecaptchaLoaded();
  }, []);
}
